import React, { Fragment, memo, useEffect, useCallback, useState } from "react";
import { Route, Link, useLocation, Redirect, useHistory } from "react-router-dom";

import { useAxiomState, useAxiomEvent } from "__AxiomComponents/AxiomHooks/AxiomHooks";
import AxiomLoader from "__AxiomComponents/AxiomUI/AxiomLoader/AxiomLoader.jsx";
import AxiomSnackBar from "__AxiomComponents/AxiomSnackBar/AxiomSnackBar.jsx";
import LandingPage from "../LandingPage/LandingPage";
import AllApps from "../AllApps/AllApps";
import ChangePassword from "../ChangePassword/ChangePassword";
import { useAxiomAppContext } from "__AxiomComponents/AxiomHooks/AxiomHooks";


import "./Home.scss";

import DefaultLogo from "../../images/hawkeye-logo.svg";
import NetraixLogo from "../../images/Group427319115(1).svg";

import { checkMobileDevice } from "../homeUtils.js";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";


function Home(props) {
  const { appSettings, userInfo, resetpreferredLanguage = () => { }, preferredLanguage } = props;
  const contextData = useAxiomAppContext();

  const [state, dispatch] = useAxiomState(
    {
      loading: true,
      apps: [],
      favouriteApps: [],
      delayRemarks: []
    },
    props.appName,
    props.appID,
    "Home",
    props.componentID
  );


  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (appSettings && appSettings.theme && appSettings.theme.length > 0) {
      appSettings.theme.forEach((item) => {
        document.body.style.setProperty(item.key, item.value);
      });
    }
  }, [appSettings]);


  const showMessage = useAxiomEvent(props.appName, props.appID, "AxiomLayout", props.componentID);

  const { pathname } = useLocation();

  useEffect(() => {
    if (!state.userDetailsForUserManagement) {
      dispatch({ email: userInfo?.email }, "AxiomEvent", "getUserDetails");
    }
  }, [state.userDetailsForUserManagement, dispatch, userInfo?.email])

  useEffect(() => {
    const isMobileDevice = checkMobileDevice(
      appSettings ? appSettings.forcefullyDisableMobileView : false
    );
    if (!window.location.href.toString().includes("change-password")) {
      dispatch({ isMobileDevice: isMobileDevice }, "AxiomEvent", "GetDashboardAndApps");
    } else {
      dispatch({
        loading: false,
      });
    }
  }, [dispatch, appSettings]);

  const landingPageApps = state.favouriteApps;

  const favouriteApp = useCallback(
    (event, app) => {
      event.preventDefault();
      const isAlreayFavourite = state.favouriteApps.some((d) => d.name === app.name);
      if (!isAlreayFavourite) {
        dispatch({ loading: true });
        dispatch({ app }, "AxiomEvent", "FavouriteApp");
      }
    },
    [dispatch, state.favouriteApps]
  );

  const unfavouriteApp = useCallback(
    (event, app) => {
      event.preventDefault();
      dispatch({ loading: true });
      dispatch({ app }, "AxiomEvent", "UnfavouriteApp");
    },
    [dispatch]
  );

  const changePassword = useCallback(
    (oldPassword, newPassword) => {
      AxiomAPIs.updatepassword(newPassword, oldPassword, (cb) => {
        if (cb.status) {
          AxiomAPIs.logout(() => { });
          location.href = window.location.origin + window.location.pathname;
        } else {
          showMessage({
            snackOpen: true,
            snackMessage: cb.error.message,
            snackType: "error",
          });
        }
      });
    },
    [showMessage]
  );

  const logo = appSettings && appSettings.appLogo ? appSettings.appLogo : DefaultLogo;

  const history = useHistory();

  useEffect(() => {
    if (!window.location.href.toString().includes("change-password")) {
      if (landingPageApps.length == 0) {
        history.replace({ pathname: "/all-apps" });
      } else {
        history.replace({ pathname: "/favourite-apps" });
      }
    }
  }, [landingPageApps, history]);

  const handleAccessRefreshUserManagement = () => {
    dispatch({ loading: true })
    dispatch({ userDetails: state.userDetailsForUserManagement }, "AxiomEvent", "runUserManagement")
  }

  const handleRemarksEdit = () => {
    handleCloseMenu()
    dispatch({ loading: true })
    dispatch({}, "AxiomEvent", "fetchDashboardCategories")
  }

  useEffect(() => {
    dispatch({}, "AxiomEvent", "getDashboardRefreshTimes")
  }, [dispatch])

  const handleDelayRemarksSubmit = () => {
    const dataToSend = Object.entries(state.delayRemarks || {})
      .filter(([_, value]) =>
        value?.remarks?.trim()
      )
      .map(([dashboardCategory, value]) => ({
        dashboardCategory,
        remarks: value.remarks.trim(),
        fromDateTime: value.fromDateTime,
        toDateTime: value.toDateTime
      }));
    if (!dataToSend.length) {
      dispatch({
        snack: {
          message: "No data found",
          snackOpen: true,
          type: 'error'
        }
      })
      return;
    }
    const invalid = dataToSend.find(item =>
      !item.fromDateTime ||
      !item.toDateTime ||
      new Date(item.fromDateTime) >= new Date(item.toDateTime)
    );
    if (invalid) {
      dispatch({
        snack: {
          message: "To Date and from Date are invalid",
          snackOpen: true,
          type: 'error'
        }
      })
      return;
    }
    dispatch(
      {
        delayRemarks: dataToSend
      },
      "AxiomEvent",
      "saveDashboardDelayRemarks"
    );
    dispatch({ openDelayRemarksModal: false })
  }
  const[isScorlled,setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if(window.scrollY > 20){
        setIsScrolled(true);
      }
      else{
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll",handleScroll);
    return () => {
      window.removeEventListener("scroll",handleScroll);
    };
  },[]);

  return (
    <div className="axiom-home">
      {state.loading && (
        <AxiomLoader
          background={"rgba(255, 255, 255, 0.4)"}
          fullScreen={true}
          block=".axiom-home"
        />
      )}
      <div className={`axiom-home-navbar ${pathname.substr(1)} ${isScorlled ? "scrolled" : ""}`}>
        <Link to="/favourite-apps" className="axiom-home-logo" tabIndex="0">
          <img src={logo} className="axiom-home-logo-image" />
        </Link>
        <img style={{ height: '65px', width: '300px', position: 'relative', bottom: '10px' }} src={NetraixLogo} alt="noneeeeeeeee"></img>

        {props.userInfo && (
          <>
            <div
              className="axiom-home-user"
              onClick={handleOpenMenu}
            >
              {props.userInfo.profilePhoto ? (
                <img
                  className="axiom-home-user-avatar"
                  src={props.userInfo.profilePhoto}
                  alt=""
                />
              ) : (
                <div className="axiom-home-user-avatar">
                  {props.userInfo.name?.charAt(0)}
                </div>
              )}
              <div className="axiom-home-user-info">
                <div className="axiom-home-user-name">
                  {props.userInfo.name}
                </div>
                <div className="axiom-home-user-role">
                  {props.userRole || "User"}
                </div>
              </div>
              <KeyboardArrowDownRoundedIcon
                className="axiom-home-user-arrow"
              />
            </div>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleCloseMenu}
              transformOrigin={{
                horizontal: "right",
                vertical: "top"
              }}
              anchorOrigin={{
                horizontal: "right",
                vertical: "bottom"
              }}
              PaperProps={{
                className: "user-dropdown-menu"
              }}
            >
              {props.isShowChangePassword && (
                <MenuItem
                  component="a"
                  href="/apps/Home/#/change-password"
                >
                  Change Password
                </MenuItem>
              )}
              {preferredLanguage && (
                <MenuItem
                  onClick={() => {
                    resetpreferredLanguage();
                    handleCloseMenu();
                  }}
                >
                  Change Language
                </MenuItem>
              )}
              <MenuItem
                onClick={() => {
                  props.logout();
                  handleCloseMenu();
                }}
              >
                Logout
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleAccessRefreshUserManagement()
                }}
              >
                Refresh Access
              </MenuItem>
              {contextData.hasDelayEditAccess && (
                <MenuItem
                  onClick={
                    handleRemarksEdit
                  }
                >
                  Edit Remarks
                </MenuItem>
              )}
            </Menu>
          </>
        )}
      </div>
      <Fragment>
        <Route path={"/favourite-apps"}>
          <LandingPage
            loading={state.loading}
            appSettings={appSettings}
            favouriteApps={landingPageApps}
            unfavouriteApp={unfavouriteApp}
            apps={state.apps}
          />
        </Route>
        <Route path={"/change-password"}>
          <ChangePassword
            appName={props.appName}
            appID={props.appID}
            componentID={props.componentID}
            changePassword={changePassword}
            userInfo={userInfo}
          />
        </Route>

        <Route path={"/all-apps"}>
          <AllApps
            loading={state.loading}
            apps={state.apps}
            favouriteApps={state.favouriteApps}
            favouriteApp={favouriteApp}
            unfavouriteApp={unfavouriteApp}
            appSettings={appSettings}
            refreshTimesRes={state.refreshTimesRes}
          />
        </Route>
        <Route exact path="/">
          <Redirect to="/favourite-apps" />
        </Route>
      </Fragment>
      {appSettings &&
        appSettings.appCopyRight &&
        appSettings.appCopyRight.copyrightText &&
        appSettings.appCopyRight.isCopyRightText.toString() == "true" ? (
        <div className="copyright-home-bottom-container">
          {appSettings.appCopyRight.copyrightText}
        </div>
      ) : null}
      <AxiomSnackBar
        snackOpen={state.snack?.snackOpen}
        message={state.snack?.message}
        type={state.snack?.type ? state.snack?.type : 'error'}
        onClose={() => { dispatch({ snack: {} }) }}
      />

      {state.openDelayRemarksModal && (
        <div
          className="delay-modal-overlay"
          onClick={() =>
            dispatch({
              openDelayRemarksModal: false
            })
          }
        >
          <div
            className="delay-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="delay-modal-header">
              <div>
                <h2>Dashboard Delay Remarks</h2>
                <p>
                  Enter the reason for delay for each dashboard category.
                </p>
              </div>
              <button
                className="delay-modal-close"
                onClick={() =>
                  dispatch({
                    openDelayRemarksModal: false
                  })
                }
              >
                ✕
              </button>
            </div>
            <div className="delay-modal-body">
              {state.dashboardCategories.map(({ dashboardCategory }, i) => (
                <div
                  className="delay-remarks-item"
                  key={dashboardCategory}
                >
                  <div className="delay-remarks-category">
                    {dashboardCategory}
                  </div>
                  <div className="delay-remarks-time-row">
                    <div className="delay-remarks-field">
                      <label>From</label>
                      <input
                        type="datetime-local"
                        className="delay-remarks-date"
                        value={
                          state.delayRemarks?.[dashboardCategory]?.fromDateTime || ""
                        }
                        onChange={(e) =>
                          dispatch({
                            delayRemarks: {
                              ...state.delayRemarks,
                              [dashboardCategory]: {
                                ...(state.delayRemarks?.[dashboardCategory] || {}),
                                fromDateTime: e.target.value
                              }
                            }
                          })
                        }
                      />
                    </div>
                    <div className="delay-remarks-field">
                      <label>To</label>
                      <input
                        type="datetime-local"
                        className="delay-remarks-date"
                        value={
                          state.delayRemarks?.[dashboardCategory]?.toDateTime || ""
                        }
                        onChange={(e) =>
                          dispatch({
                            delayRemarks: {
                              ...state.delayRemarks,
                              [dashboardCategory]: {
                                ...(state.delayRemarks?.[dashboardCategory] || {}),
                                toDateTime: e.target.value
                              }
                            }
                          })
                        }
                      />
                    </div>
                  </div>
                  <textarea
                    className="delay-remarks-input"
                    rows={4}
                    placeholder="Enter reason for delay..."
                    value={
                      state.delayRemarks?.[dashboardCategory]?.remarks || ""
                    }
                    onChange={(e) =>
                      dispatch({
                        delayRemarks: {
                          ...state.delayRemarks,
                          [dashboardCategory]: {
                            ...(state.delayRemarks?.[dashboardCategory] || {}),
                            remarks: e.target.value
                          }
                        }
                      })
                    }
                  />
                </div>
              ))}
            </div>
            <div className="delay-modal-footer">
              <button
                className="delay-btn-secondary"
                onClick={() =>
                  dispatch({
                    openDelayRemarksModal: false
                  })
                }
              >
                Cancel
              </button>
              <button
                className="delay-btn-primary"
                // onClick={() => {
                //   dispatch({
                //     openDelayRemarksModal: false
                //   });
                // }}
                onClick={handleDelayRemarksSubmit}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default memo(Home);
